<template>
    <div style="width: 100%; height: 100vh;">
        <img style="width: 100%; height: 90vh;" src="https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/4fbf9d58-268e-4bd1-b484-42766c834ad3.png" alt="">
     
    </div>
  </template>
  <script>
  export default{
    data(){
        return{

        }
    },
    

  }

</script>


// WEBPACK FOOTER //
// src/views/goods/Home.vue